import { Remarkable } from 'remarkable';
import { linkify } from 'remarkable/linkify';
import emoji from 'remarkable-emoji';
import RemarkableReactRenderer from 'remarkable-react';
import {
  A,
  Blockquote,
  Code,
  Del,
  Hr,
  Img,
  Li,
  Ol,
  P,
  Pre,
  Strong,
  Ul,
} from '../components/Markdown';

export const markdown = new Remarkable().use(linkify).use(emoji);

markdown.block.ruler.disable(['heading', 'table', 'footnote']);
markdown.renderer = new RemarkableReactRenderer({
  components: {
    a: A,
    blockquote: Blockquote,
    code: Code,
    del: Del,
    hr: Hr,
    img: Img,
    li: Li,
    ol: Ol,
    p: P,
    pre: ({ content, params: language }) => (
      <Pre content={content.trim()} language={language} />
    ),
    strong: Strong,
    ul: Ul,
  },
});
